import React from "react"
import { get, map, maxBy, size } from "lodash"

import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"
import { makeSentenceBreakList } from "utils/util"
import { useStockBenefitData } from "components/actions/symbolDetail"
import { useSelector } from "react-redux"

type BenefitProps = {
  symbolDetail: APIResponse.Res
}

export const Benefit: React.FC<BenefitProps> = props => {
  const symbol = get(props.symbolDetail, "Symbol")
  const isRefresh = useSelector(
    (state: { symbolDetail: { refresh: boolean } }) =>
      state.symbolDetail.refresh
  )
  const data = useStockBenefitData(symbol, isRefresh)

  const benefitList = get(data, "ResultList")
  const mainData = maxBy(benefitList, (obs: object) =>
    size(get(obs, "RightAllotDayList"))
  )
  return (
    <div className="split-division split-two-division panel-benefit">
      <div className="title-table-container">
        {mainData ? (
          <div>
            <div className="split-division split-two-division">
              <div className="panel-splits panel-left">
                <InfoTable
                  list={infoTableColumns.symbolDetail.stockBenefit.info}
                  data={mainData}
                  className="table-striped table-index-detail"
                  wrapperCls="index-detail-table-row"
                />
                <img src={get(mainData, "ImageUrl")} />
              </div>
              <div className="panel-splits title-table-container">
                <div className="title-border">優待内容</div>
                {map(benefitList, (li: APIResponse.Res, i: number) => {
                  const rightAllotDayList = get(li, "RightFixMonthList")
                  return (
                    <div key={i}>
                      <div className="title-border">
                        {map(rightAllotDayList, (date: number, i: number) => (
                          <span key={i}>
                            {`${date}月`}
                            {rightAllotDayList.length - 1 !== i ? "," : ""}
                          </span>
                        ))}
                        の優待内容
                      </div>
                      <div>
                        {map(
                          makeSentenceBreakList(li, "Content"),
                          (str: string, i: number) => (
                            <div key={i}>{str}</div>
                          )
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        ) : (
          <div>株主優待情報はございません</div>
        )}
      </div>
    </div>
  )
}
